import Axios from './axios_wrapper'

export function getEngagementTypes() {
  return Axios({
    url: `/engagement_types`
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/engagement_types.js
// module id = null
// module chunks = 